import { render, staticRenderFns } from "./compLeaveapp.vue?vue&type=template&id=4fca90b9&"
import script from "./compLeaveapp.vue?vue&type=script&lang=js&"
export * from "./compLeaveapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports